/* eslint-disable @next/next/no-img-element */
import { ArrowLeft } from 'lucide-react'
import Link from 'next/link'

import ResetPasswordForm from '@/components/forms/auth/reset-password-form'

import { NON_FSDS_DEFAULT_LOGO_URL } from '@/configs/non-fsds-config'
import { TEMPLATE_DEFAULT_URLS } from '@/configs/template-default-urls'

export interface NonFsdsResetPasswordSectionProps {
  title: string
  subtitle: string
  logoUrl: string
  backLinkText: string
  brandHref?: string
  signInUrl?: string
}

export default function NonFsdsResetPasswordSection({
  title = 'Set new password',
  subtitle = 'Your new password must be different to previously used passwords.',
  logoUrl = NON_FSDS_DEFAULT_LOGO_URL,
  backLinkText = 'Back to sign in',
  brandHref = TEMPLATE_DEFAULT_URLS.home,
  signInUrl = TEMPLATE_DEFAULT_URLS.signIn,
}: NonFsdsResetPasswordSectionProps) {
  return (
    <div className="relative flex min-h-svh flex-col items-center justify-center overflow-hidden bg-slate-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="pointer-events-none absolute left-0 top-0 h-full w-full bg-[radial-gradient(circle_at_top_left,_var(--tw-gradient-stops))] from-blue-100 via-transparent to-transparent opacity-40" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-blue-500/10 blur-3xl" />
      <div className="pointer-events-none absolute left-10 top-20 h-72 w-72 rounded-full bg-blue-300/10 blur-3xl" />

      <div className="relative z-10 w-full max-w-md rounded-3xl border border-slate-100/50 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:p-12">
        <div className="mb-8 flex justify-center">
          <Link href={brandHref} className="inline-block transition-transform duration-200 hover:scale-105 active:scale-95">
            <img src={logoUrl} alt="Logo" className="h-10 w-auto" />
          </Link>
        </div>

        <div className="mb-8 text-center">
          <h2 className="mb-2 text-2xl font-bold text-slate-900">{title}</h2>
          <p className="mx-auto max-w-sm text-sm text-slate-500">{subtitle}</p>
        </div>

        <div className="w-full">
          <ResetPasswordForm buttonClassName="w-full rounded-xl border border-blue-700 bg-blue-600 text-white shadow-md transition-all duration-200 hover:bg-blue-700 hover:shadow-blue-600/25" />
        </div>

        <div className="mt-8 text-center">
          <Link
            href={signInUrl}
            className="inline-flex items-center justify-center rounded-md text-sm font-semibold text-slate-500 transition-colors hover:text-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {backLinkText}
          </Link>
        </div>
      </div>
    </div>
  )
}
